import { useRouter } from 'next/router';
import { useCallback, useEffect } from 'react';
import {
  CONFIRMATION_SUBPATH,
  CHECKOUT_SUBPATH,
  APP_CONFIRMATION_SUBPATH,
} from './routing';

// When state machine changes the step, update URL to match
// This is very important, without changing the URL the new props for the page cannot be fetched.
export const useSyncPathToMachine = (
  routeChanging,
  isAppSession,
  stateKey,
  unmappedStates,
  pet_id,
  setShowPlanSelection,
) => {
  const router = useRouter();
  const [subpath, slug] = router.query.path ?? [];
  const pathname = slug ? `${subpath}/${slug}` : subpath;

  const syncPathToMachine = useCallback(() => {
    if (!routeChanging.current) {
      const query = isAppSession ? { isAppSession } : {};
      if (
        stateKey &&
        (stateKey === CONFIRMATION_SUBPATH ||
          stateKey === CHECKOUT_SUBPATH ||
          stateKey === APP_CONFIRMATION_SUBPATH) &&
        pathname !== stateKey
      )
        router.push({
          pathname: `${stateKey}`,
          query,
        });
      else if (
        stateKey &&
        pathname !== stateKey &&
        !unmappedStates.includes(stateKey)
      ) {
        query.pet_id = pet_id;
        router.push({
          pathname: `${stateKey}`,
          query,
        });
      }
    }
  }, [
    pathname,
    router,
    isAppSession,
    pet_id,
    routeChanging,
    stateKey,
    unmappedStates,
  ]);

  useEffect(() => {
    syncPathToMachine();
    const onRouteChangeComplete = () => {
      routeChanging.current = false;
      syncPathToMachine();
      setShowPlanSelection(false);
    };

    router.events.on('routeChangeComplete', onRouteChangeComplete);
    return () => {
      router.events.off('routeChangeComplete', onRouteChangeComplete);
    };
  }, [syncPathToMachine, router, routeChanging, setShowPlanSelection]);
};
